import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDemoCtx } from './DemoContext';
import bgVideo from '../../assets/bg1.mp4';

export default function DemoLogin() {
    const navigate = useNavigate();
    const { toast } = useDemoCtx();
    const [showPw, setShowPw] = useState(false);

    const doLogin = () => {
        toast('로그인 중...', 'success');
        setTimeout(() => {
            navigate('/demo/dashboard');
            setTimeout(
                () => toast('환영합니다! 김관리자님 👋', 'success'),
                350,
            );
        }, 650);
    };

    return (
        <div className="gmw gmw-auth" style={{ background: 'transparent' }}>
            {/* 동영상 배경 */}
            <div
                style={{
                    position: 'fixed',
                    inset: 0,
                    zIndex: 0,
                    overflow: 'hidden',
                }}
            >
                <video
                    autoPlay
                    muted
                    loop
                    playsInline
                    style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                    }}
                >
                    <source src={bgVideo} type="video/mp4" />
                </video>
                <div
                    style={{
                        position: 'absolute',
                        inset: 0,
                        background: 'rgba(0,20,10,0.52)',
                    }}
                />
            </div>

            <div className="auth-card fade-up">
                <div className="auth-logo d-flex align-items-center justify-content-center">
                    <div className="auth-logo-mark">🌿</div>
                    <div className="auth-logo-name">
                        <em>스마트</em> TreeMap
                    </div>
                </div>
                <div className="auth-card-title">로그인</div>
                <div className="auth-card-sub">
                    트리맵 수목 관리 플랫폼에 오신 것을 환영합니다
                </div>
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 15,
                    }}
                >
                    <div className="form-group">
                        <label className="form-label">이메일</label>
                        <div className="icon-field">
                            <span className="field-ico">✉️</span>
                            <input
                                type="email"
                                className="form-input"
                                placeholder="admin@company.com"
                                defaultValue="demo@treemap.kr"
                            />
                        </div>
                    </div>
                    <div className="form-group">
                        <label className="form-label">비밀번호</label>
                        <div className="pw-wrap">
                            <input
                                type={showPw ? 'text' : 'password'}
                                className="form-input"
                                placeholder="비밀번호 입력"
                                defaultValue="password123"
                            />
                            <button
                                className="pw-eye"
                                onClick={() => setShowPw(p => !p)}
                            >
                                {showPw ? '🙈' : '👁'}
                            </button>
                        </div>
                        <div style={{ textAlign: 'right', marginTop: 5 }}>
                            <span
                                style={{
                                    fontSize: 12,
                                    color: 'var(--primary)',
                                    cursor: 'pointer',
                                    fontWeight: 600,
                                }}
                                onClick={() =>
                                    toast(
                                        '비밀번호 재설정 이메일을 발송했습니다',
                                        'success',
                                    )
                                }
                            >
                                비밀번호 찾기
                            </span>
                        </div>
                    </div>
                    <label className="check-wrap checked">
                        <span className="check-box" />
                        <span className="check-label">
                            로그인 상태 유지 (30일)
                        </span>
                    </label>
                    <button
                        className="btn btn-primary btn-lg w-full"
                        style={{ marginTop: 4 }}
                        onClick={doLogin}
                    >
                        로그인
                    </button>
                </div>
                <div className="divider-text" style={{ margin: '20px 0' }}>
                    <span>또는</span>
                </div>
                <div className="auth-footer">
                    아직 계정이 없으신가요?{' '}
                    <a onClick={() => navigate('/demo/join')}>무료 회원가입</a>
                </div>
            </div>
        </div>
    );
}
